__turbopack_context__.v({
  "activeButtonStyles": "pagination-module-scss-module__uIYoSq__activeButtonStyles",
  "ellipsisStyles": "pagination-module-scss-module__uIYoSq__ellipsisStyles",
  "leftArrowButtonStyles": "pagination-module-scss-module__uIYoSq__leftArrowButtonStyles",
  "leftArrowNoHoverStyles": "pagination-module-scss-module__uIYoSq__leftArrowNoHoverStyles",
  "mobilePagePositionIndicatorStyles": "pagination-module-scss-module__uIYoSq__mobilePagePositionIndicatorStyles",
  "paginationButtonStyles": "pagination-module-scss-module__uIYoSq__paginationButtonStyles",
  "paginationButtonsWrapper": "pagination-module-scss-module__uIYoSq__paginationButtonsWrapper",
  "paginationWrapper": "pagination-module-scss-module__uIYoSq__paginationWrapper",
  "rightArrowButtonStyles": "pagination-module-scss-module__uIYoSq__rightArrowButtonStyles",
  "rightArrowNoHoverStyles": "pagination-module-scss-module__uIYoSq__rightArrowNoHoverStyles",
});
